import { render } from "./CookieConsentDialog.vue?vue&type=template&id=661f0bf4&scoped=true"
import script from "./CookieConsentDialog.vue?vue&type=script&lang=js"
export * from "./CookieConsentDialog.vue?vue&type=script&lang=js"

import "./CookieConsentDialog.vue?vue&type=style&index=0&id=661f0bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661f0bf4"]])

export default __exports__